import React from 'react';
import Hero from '../components/home/Hero';
import ToolsSection from '../components/home/ToolsSection.jsx';
import EducationPlatformSection from '../components/home/EducationPlatformSection.jsx';
import CommunitySection from '../components/home/CommunitySection.jsx';
import ResourcesSupportSection from '../components/home/ResourcesSupportSection.jsx';

function Home() {
  return (
    <>
      <Hero />
      <ToolsSection />

      <section className="bg-icetex py-[80px] px-5">
        <div className="flex gap-[30px] max-w-[1400px] mx-auto max-[1100px]:flex-col">
          <EducationPlatformSection />
          <CommunitySection />
          <ResourcesSupportSection />
        </div>
      </section>
    </>
  );
}

export default Home;
